enum EventType {
	RESIZE = 'resize',
	LOAD = 'load',
	MOUSE_UP = 'mouseup',
	MOUSE_MOVE = 'mousemove',
	SCROLL_DOWN = 'scroll-down',
	SCROLL_UP = 'scroll-up',
	SCROLL_HIDDEN = 'scroll-hidden',
	X_LARGE_SCREEN = 'extra-large-screen',
	LARGE_SCREEN = 'large-screen',
	MEDIUM_SCREEN = 'medium-screen',
	SMALL_SCREEN = 'small-screen',
	X_SMALL_SCREEN = 'extra-small-screen',
}

export default EventType;